const dzData = [
  {
    "a_sin": "BCD0000EFG",
    "sku": "PD1200",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MK99-Black.jpg"
  },
  {
    "a_sin": "BCD1111EFG",
    "sku": "MK99-Black",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MK99.jpg"
  },
  {
    "a_sin": "B07MFYQBTX",
    "sku": "MK99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MK99.jpg"
  },
  {
    "a_sin": "B0DRVGKTG4",
    "sku": "MK99-Black",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MK99-Black.jpg"
  },
  {
    "a_sin": "B09NKNSQ2T",
    "sku": "FK99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FK99.jpg"
  },
  {
    "a_sin": "B07J9QRVDM",
    "sku": "MP99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MP99.jpg"
  },
  {
    "a_sin": "B08NY78DC3",
    "sku": "MS99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MS99.jpg"
  },
  {
    "a_sin": "B08PCJNPHR",
    "sku": "MV99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MV99.jpg"
  },
  {
    "a_sin": "B08NDYVZV5",
    "sku": "SK99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SK99.jpg"
  },
  {
    "a_sin": "B08NDXVPC9",
    "sku": "SP99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SP99.jpg"
  },
  {
    "a_sin": "B083DFW1QS",
    "sku": "PD600-TAM3",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-PD600-TAM3.jpg"
  },
  {
    "a_sin": "B0B3181JK6",
    "sku": "PD800-TAM4",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-PD800-TAM4.jpg"
  },
  {
    "a_sin": "B0B319RF4D",
    "sku": "PD1000-TAM4",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-PD1000-TAM4.jpg"
  },
  {
    "a_sin": "B08PYHJ8CJ",
    "sku": "PD400",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-PD400.jpg"
  },
  {
    "a_sin": "B08R8FD43K",
    "sku": "PX500-A",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-PX500-A.jpg"
  },
  {
    "a_sin": "B0DBHJ7W1V",
    "sku": "PX600",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-PX600.jpg"
  },
  {
    "a_sin": "B0DBHLCSVV",
    "sku": "PD1200",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-PD1200.jpg"
  },
  {
    "a_sin": "B09ND9WS22",
    "sku": "GX99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-GX99.jpg"
  },
  {
    "a_sin": "B08FD1V2TC",
    "sku": "TAM3",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TAM3.jpg"
  },
  {
    "a_sin": "B09WMM6D6P",
    "sku": "TAM4",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TAM4.jpg"
  },
  {
    "a_sin": "B0967NM5T7",
    "sku": "TD-3",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TD-3.jpg"
  },
  {
    "a_sin": "B0DL5889NN",
    "sku": "TD-9",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TD-9.jpg"
  },
  {
    "a_sin": "B0C2BVRDWJ",
    "sku": "ROK3-A",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-ROK3-A.jpg"
  },
  {
    "a_sin": "B0DBQ2ZWW7",
    "sku": "T900",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-T900.jpg"
  },
  {
    "a_sin": "B0DBPCRPBP",
    "sku": "TF900",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TF900.jpg"
  },
  {
    "a_sin": "B0CJ2NNVM6",
    "sku": "SS99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SS99.jpg"
  },
  {
    "a_sin": "B0BZRT18QY",
    "sku": "DS99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DS99.jpg"
  },
  {
    "a_sin": "B0CJ2QC33R",
    "sku": "TS99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TS99.jpg"
  },
  {
    "a_sin": "B0CFPRWVZG",
    "sku": "UDS99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-UDS99.jpg"
  },
  {
    "a_sin": "B0CKMQ19XM",
    "sku": "WB99-C",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-WB99-C.jpg"
  },
  {
    "a_sin": "B0DJ6V2SP4",
    "sku": "WB99-CH",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-WB99-CH.jpg"
  },
  {
    "a_sin": "B0C58TH95C",
    "sku": "WB99-H",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-WB99-H.jpg"
  },
  {
    "a_sin": "B0BZRYS696",
    "sku": "DS99-S",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DS99-S.jpg"
  },
  {
    "a_sin": "B0CJ2N5D1W",
    "sku": "TS99-S",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TS99-S.jpg"
  },
  {
    "a_sin": "B0CFPVN7YN",
    "sku": "UDS99-S",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-UDS99-S.jpg"
  },
  {
    "a_sin": "B095YHD5RF",
    "sku": "FAF50",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FAF50.jpg"
  },
  {
    "a_sin": "B0DF78DNTW",
    "sku": "FAF100",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FAF100.jpg"
  },
  {
    "a_sin": "B0DP22761C",
    "sku": "BFRO100",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-BFRO100.jpg"
  },
  {
    "a_sin": "B0DSKG73XB",
    "sku": "LP365",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-LP365.jpg"
  },
  {
    "a_sin": "B0DSKG5NVZ",
    "sku": "LP365-P",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-LP365-P.jpg"
  },
  {
    "a_sin": "B0F8BFW5KV",
    "sku": "LP365",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-LP365.jpg"
  },
  {
    "a_sin": "B0F8BH2Y78",
    "sku": "LP365-P",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-LP365-P.jpg"
  },
  {
    "a_sin": "B09W1XVVF1",
    "sku": "SW10",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SW10.jpg"
  },
  {
    "a_sin": "B09W1YTTB4",
    "sku": "SW15",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SW15.jpg"
  },
  {
    "a_sin": "B09W1Y9JZY",
    "sku": "SW20",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SW20.jpg"
  },
  {
    "a_sin": "B09W1YDNDL",
    "sku": "SW10F",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SW10F.jpg"
  },
  {
    "a_sin": "B09W1Y557B",
    "sku": "SW15F",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SW15F.jpg"
  },
  {
    "a_sin": "B09W1ZHTVX",
    "sku": "SW20F",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-SW20F.jpg"
  },
  {
    "a_sin": "B0CZ3NBTVQ",
    "sku": "DW10",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DW10.jpg"
  },
  {
    "a_sin": "B0CZ3D2SR9",
    "sku": "DW15",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DW15.jpg"
  },
  {
    "a_sin": "B09W1ZLJ3Y",
    "sku": "DW10F",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DW10F.jpg"
  },
  {
    "a_sin": "B09W1ZCR4K",
    "sku": "DW15F",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DW15F.jpg"
  },
  {
    "a_sin": "B0CZNCYYDV",
    "sku": "TW10",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TW10.jpg"
  },
  {
    "a_sin": "B0CZNZ4RRJ",
    "sku": "TW15",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-TW15.jpg"
  },
  {
    "a_sin": "B0DGKZ6FPW",
    "sku": "DH80",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DH80.jpg"
  },
  {
    "a_sin": "B0DSKDHWNG",
    "sku": "DH80-G",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DH80-G.jpg"
  },
  {
    "a_sin": "B0DSKD4MGX",
    "sku": "DH80-B",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-DH80-B.jpg"
  },
  {
    "a_sin": "B0CLGGQ7DB",
    "sku": "G190-STANDARD",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-G190-STANDARD.jpg"
  },
  {
    "a_sin": "B0CLGH2128",
    "sku": "G210-STANDARD",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-G210-STANDARD.jpg"
  },
  {
    "a_sin": "B0CLGGZKPC",
    "sku": "G210-PRO",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-G210-PRO.jpg"
  },
  {
    "a_sin": "B0CLGJWJ3Z",
    "sku": "G210-PROX",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-G210-PROX.jpg"
  },
  {
    "a_sin": "B08X4BYCFL",
    "sku": "FP40-D",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FP40-D.jpg"
  },
  {
    "a_sin": "B0CRYN94RD",
    "sku": "FF1080",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FF1080.jpg"
  },
  {
    "a_sin": "B0D99NBW3C",
    "sku": "FF1440",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FF1440.jpg"
  },
  {
    "a_sin": "B0DB86F5RJ",
    "sku": "FF1080-EX",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FF1080-EX.jpg"
  },
  {
    "a_sin": "B0DRVCTYGS",
    "sku": "FF1080-S",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FF1080-S.jpg"
  },
  {
    "a_sin": "B0D9B193BV",
    "sku": "FD1440",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FD1440.jpg"
  },
  {
    "a_sin": "B0D997YFP3",
    "sku": "FD360",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FD360.jpg"
  },
  {
    "a_sin": "B0D99VD35K",
    "sku": "FD1440-B",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FD1440-B.jpg"
  },
  {
    "a_sin": "B0DRV96R6K",
    "sku": "FD1440-EX",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FD1440-EX.jpg"
  },
  {
    "a_sin": "B0DNYS2NJ1",
    "sku": "FS99",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-FS99.jpg"
  },
  {
    "a_sin": "B0DBHJ41ZH",
    "sku": "MR600 White",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MR600%20White.jpg"
  },
  {
    "a_sin": "B0DBHG4FMB",
    "sku": "MR600 Black",
    "img_url": "https://cdn.shopify.com/s/files/1/0159/8429/5990/files/product-img-MR600%20Black.jpg"
  }
];